import type { ReactNode, FC } from 'react';
import cn from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import StudioHeading from '../../../StudioHeading';

import s from './BaseHeader.scss';

interface Props {
  title?: ReactNode;
  titleSlot?: ReactNode;
  middleSlot?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const BaseHeader: FC<Props> = ({ title, titleSlot, middleSlot, subtitle, actions, className }) => (
  <div className={s['wrapper']}>
    <header className={cn(s['root'], className)}>
      {title ? (
        <StudioHeading>{title}</StudioHeading>
      ) : (
        <div className={s['title-slot']}>{titleSlot}</div>
      )}
      <div className={s['middle-slot']}>{middleSlot}</div>
      <BiLoggerContextProvider value={{ sectionname: 'header_actions' }}>
        <div className={s['actions']}>{actions}</div>
      </BiLoggerContextProvider>
    </header>
    {subtitle && <div className={s['subtitle']}>{subtitle}</div>}
  </div>
);
BaseHeader.displayName = 'BaseHeader';

export default BaseHeader;
